module.exports = __webpack_public_path__ + "unittype-icon.png?e25f7eda4362c928856f92c6eae65bf7";